import disolutor1 from '../disolutor/disolutor1.png'

const disolutorImages = [
    disolutor1,
]

export default disolutorImages